import dayjs from 'dayjs';

export function buildCreateTerminUrl(day: dayjs.Dayjs): string {
  return `/termine/uebersicht/${day.format('YYYY')}/${day.format('M')}/${day.format('D')}/create`;
}
